export const getConsolidateInvoiceDescription = (code, company) => {
  if (!code || !company) return ""

  const agreement = company.consolidateAgreement.find(
    a => a.ConsolidateCode === code
  )

  return `${agreement.ConsolidateCode} - ${agreement.ConsolidateDescription}`
}
